import React, { memo, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { SETTINGS_TABS } from "../../constants";
import { SidebarBadge, SidebarIcon, SidebarItem, SidebarLabel, SidebarRoot } from "./elements";
import { SettingsTabIcons } from "./icons";

export const BettoSettingsSidebar = memo(
	({ activeTab, onTabChange, translate, showSecurityWarning }) => {
		const handleTabClick = useCallback(
			(tabId) => () => {
				onTabChange(tabId);
			},
			[onTabChange]
		);

		const tabs = useMemo(
			() =>
				SETTINGS_TABS.map((tab) => ({
					...tab,
					showBadge: tab.hasWarning && showSecurityWarning && tab.id === "security",
				})),
			[showSecurityWarning]
		);

		return (
			<SidebarRoot aria-label={translate("betto.profile.globalSettings")}>
				{tabs.map((tab) => (
					<SidebarItem
						key={tab.id}
						type="button"
						$active={activeTab === tab.id}
						data-testid={tab.testId}
						onClick={handleTabClick(tab.id)}>
						<SidebarIcon>{SettingsTabIcons[tab.id]}</SidebarIcon>
						<SidebarLabel>{translate(tab.labelKey)}</SidebarLabel>
						{tab.showBadge ? <SidebarBadge>!</SidebarBadge> : null}
					</SidebarItem>
				))}
			</SidebarRoot>
		);
	}
);

BettoSettingsSidebar.displayName = "BettoSettingsSidebar";

BettoSettingsSidebar.propTypes = {
	activeTab: PropTypes.string.isRequired,
	onTabChange: PropTypes.func.isRequired,
	translate: PropTypes.func.isRequired,
	showSecurityWarning: PropTypes.bool,
};
